import { render } from "./recordDetail.vue?vue&type=template&id=5f45cb1e&scoped=true"
import script from "./recordDetail.vue?vue&type=script&lang=js"
export * from "./recordDetail.vue?vue&type=script&lang=js"

import "./recordDetail.vue?vue&type=style&index=0&id=5f45cb1e&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f45cb1e"],['__file',"src/views/alfmeier/quest/recordDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f45cb1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f45cb1e', __exports__)) {
    console.log('reload')
    api.reload('5f45cb1e', __exports__)
  }
  
  module.hot.accept("./recordDetail.vue?vue&type=template&id=5f45cb1e&scoped=true", () => {
    console.log('re-render')
    api.rerender('5f45cb1e', render)
  })

}


export default __exports__